export default "__VITE_ASSET__DU2MOs3Y__"